export class Versao {
    private id:         number;
    private nome:       string;
    private tipo:       string;
    private versao:     string;
    private data_inc:   string;
    private data_disp:  string;
    private hora_disp:  string;
    private situacao:   string;

    constructor() {}

    public toJSON() {
        return {
            id:         this.id,
            nome:       this.nome,
            tipo:       this.tipo,
            versao:     this.versao,
            data_inc:   this.data_inc,
            data_disp:  this.data_disp,
            hora_disp:  this.hora_disp,
            situacao:   this.situacao
        };
    }

    public toClass(versao) {
        this.id        = versao.id;
        this.nome      = versao.nome;
        this.tipo      = versao.tipo;
        this.versao    = versao.versao;
        this.data_inc  = versao.data_inc;
        this.data_disp = versao.data_disp;
        this.hora_disp = versao.hora_disp;
        this.situacao  = versao.situacao;
    }

}
